var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisabledDevicePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#939393;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,24c6.6,0,12-5.4,12-12c0-6.6-5.4-12-12-12C5.4,0,0,5.4,0,12C0,18.6,5.4,24,12,24z M12,23 c2.9,0,5.5-1.1,7.4-2.9l-7.8-7.8l-7.4,7.4C6.2,21.8,8.9,23,12,23z M3.5,19l7.4-7.4l-7-7C2.1,6.5,1,9.1,1,12C1,14.7,1.9,17.1,3.5,19z  M11.6,10.9l-7-7C6.5,2.1,9.1,1,12,1c2.7,0,5.1,0.9,7,2.5L11.6,10.9z M12.3,11.6l7.4-7.4c2,2,3.3,4.8,3.3,7.8c0,2.9-1.1,5.5-2.9,7.4 L12.3,11.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledDevicePlaceholder);
export default __webpack_public_path__ + "static/media/disabled-device-placeholder.2afef1c237b52c5ad9b3020be264a50d.svg";
export { ForwardRef as ReactComponent };